import Qs from 'qs';
export default {
  async fetchData({ commit, state }) {
    try {
      commit('layout/setLoader', true, { root: true });
      const params = {
        ...(state.pagination.limit && { limit: state.pagination.limit }),
        ...(state.pagination.offset && { offset: state.pagination.offset }),
      };

      const result = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/reports`, {
        params,
        paramsSerializer: params => {
          return Qs.stringify(params);
        },
      });

      commit('setPagination', {
        value: {
          ...state.pagination,
          countTotal: result.data.countTotal,
        },
      });
      commit('setItems', { value: result.data.reports });
      commit('layout/setLoader', false, { root: true });
    } catch {}
  },

  async generateNewReport({ dispatch, state }) {
    try {
      const response = await this.$axios.post(`${this.$config.baseOfixApi}/e-commerce/v1/reports`, {
        typeId: state.activeFilters?.typeId,
        from: state.activeFilters?.dateRange?.from,
        to: state.activeFilters?.dateRange?.to,
        emailNotifyWhenReportReady: state.activeFilters?.emailNotifyWhenReportReady,
      });

      this.$toast.success(`<div class="popupToast__content">${response.data.message}</div>`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
      });

      await dispatch('fetchData');
    } catch ({ response }) {
      this.$toast.error(`<div class="popupToast__content">${response.data.message}</div>`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
      });
    }
  },

  changeFilters({ commit, dispatch, state }, { name, value }) {
    try {
      commit('setFilter', { name, value });
    } catch {}
  },

  async fetchReportTypes({ commit, state }) {
    try {
      const result = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/report-types`,
      );

      commit('setReportTypes', { value: result.data.reportTypes });
    } catch {}
  },

  async remove({ commit, dispatch }, id) {
    try {
      await this.$axios.delete(`${this.$config.baseOfixApi}/e-commerce/v1/reports/${id}`);
      await dispatch('fetchData');
      this.$toast.success(`<div class="popupToast__content">Raport został usunięty.</div>`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
      });
    } catch (error) {
      if (error?.response?.data?.message) {
        this.$toast.error(`<div class="popupToast__content">${error.response.data.message}</div>`, {
          theme: 'popupToast__inner',
          containerClass: 'popupToast__container',
          keepOnHover: true,
          duration: 4000,
        });
      }
    }
  },

  async changePagination({ commit, dispatch }, { value }) {
    try {
      commit('setPagination', { value });
      await dispatch('fetchData');
    } catch {}
  },
};
